import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUsersListResponse {
  total: number;
  list: Array<Users>;
  page: number;
  page_size: number;
};

export interface Users {
  id: number;
  user_global_id: string;
  user_name: string;
  user_id: string;
  email: string;
  role_status: number;
  app_status: number;
  video_subscribe: number;
  article_subscribe: number;
  blog_subscribe: number;
  moments_subscribe: number;
  graphic_subscribe: number;
  ai_subscribe: number;
  expire_at: number;
  agent_user_name: string;
  created_at: number;
};

// 请求接口
interface AgentUsersListResponseRequest {
  agentId: string,
  searchType: string,
  inputText: string,
  startDate: string,
  endDate: string,
  page: number,
  pageSize: number
}

export class AgentUsersData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("userGlobalId cannot be empty")
  @IsString("userGlobalId must be a string")
  userGlobalId: string;

  @Required("User name cannot be empty")
  @IsString("User name must be a string")
  userName: string;

  @Required("User id cannot be empty")
  @IsString("User id must be a string")
  userId: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("Role status cannot be empty")
  @IsNumber("Role status must be a number")
  roleStatus: number;

  @Required("App status cannot be empty")
  @IsNumber("App status must be a number")
  appStatus: number;

  @Required("Video subscribe cannot be empty")
  @IsNumber("Video subscribe must be a number")
  videoSubscribe: number;

  @Required("Article subscribe cannot be empty")
  @IsNumber("Article subscribe must be a number")
  articleSubscribe: number;

  @Required("Blog subscribe cannot be empty")
  @IsNumber("Blog subscribe must be a number")
  blogSubscribe: number;

  @Required("Moments subscribe cannot be empty")
  @IsNumber("Moments subscribe must be a number")
  momentsSubscribe: number;

  @Required("Graphic subscribe cannot be empty")
  @IsNumber("Graphic subscribe must be a number")
  graphicSubscribe: number;

  @Required("AI subscribe cannot be empty")
  @IsNumber("AI subscribe must be a number")
  aiSubscribe: number;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  @Required("Expire at cannot be empty")
  @IsNumber("Expire at must be a number")
  expireAt: number;
}

export class AgentUsersListData {
  @IsArray("List must be an array")
  list: AgentUsersData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: AgentUsersListResponse
): AgentUsersListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUsersListData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 智能体用户列表 */
export const agentUsersList = async ({
  page,
  pageSize,
  agentId,
  searchType,
  inputText,
  startDate,
  endDate,
}: AgentUsersListResponseRequest): Promise<AgentUsersListData> => {
  const response = await api.post<AgentUsersListResponse>('/agent-v2/users/list', {
    page,
    page_size: pageSize,
    agent_id: agentId,
    search_type: searchType,
    input_text: inputText,
    start_date: startDate,
    end_date: endDate,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
